<template>
  <el-table v-if="cutView=='storage'" stripe border style="width: 100%" height="100%" size="mini"
    :data="tableData">
    <el-table-column type="index" align="center"
      :width="pagination.endIndex >= 1000 ? 80 : 50"
      :index="pagination.beginIndex"
    ></el-table-column>
    <el-table-column label="SAP单号" min-width="120px" prop="sapOrderNumber" align="center" show-overflow-tooltip>
      <template slot-scope="scope">
        <span>{{ scope.row.sapOrderNumber ? scope.row.sapOrderNumber : '-' }}</span>
      </template>
    </el-table-column>
    <el-table-column label="入库凭证号" min-width="120px" prop="mblnr" align="center" show-overflow-tooltip>
      <template slot-scope="scope">
        <span>{{ scope.row.mblnr ? scope.row.mblnr : '-' }}</span>
      </template>
    </el-table-column>
    <el-table-column label="物料编码" min-width="150px" prop="matnr" align="center" show-overflow-tooltip>
      <template slot-scope="scope">
        <el-tooltip v-if="scope.row.matnx" :content="scope.row.matnx" class="item" effect="dark" placement="top" :open-delay="300">
          <span>{{scope.row.matnr ? scope.row.matnr : '-'}}</span>
        </el-tooltip>
        <span v-else>{{scope.row.matnr ? scope.row.matnr : '-'}}</span>
      </template>
    </el-table-column>
    <el-table-column label="入库单号" min-width="150px" prop="xblnr" align="center" show-overflow-tooltip>
      <template slot-scope="scope">
        <el-tooltip v-if="scope.row.xblnr" :content="scope.row.xblnr" class="item" effect="dark" placement="top" :open-delay="300">
          <span class="textOverflow">{{ scope.row.xblnr }}</span>
        </el-tooltip>
        <span v-else>-</span>
      </template>
    </el-table-column>
    <el-table-column label="批次号" min-width="150px" prop="charg" align="center" show-overflow-tooltip>
      <template slot-scope="scope">
        <span class="textOverflow">
          {{scope.row.charg ? scope.row.charg : '-'}}
        </span>
      </template>
    </el-table-column>
    <el-table-column label="数量" min-width="80px" prop="menge" align="center" show-overflow-tooltip>
      <template slot-scope="scope">
        <span class="textOverflow">
          {{scope.row.menge}}
        </span>
      </template>
    </el-table-column>
    <el-table-column label="工厂" min-width="80px" prop="werks" align="center" show-overflow-tooltip>
      <template slot-scope="scope">
        <el-tooltip v-if="scope.row.werkstx" :content="scope.row.werkstx" class="item" effect="dark" placement="top" :open-delay="300">
          <span class="textOverflow">
            {{scope.row.werks}}
          </span>
        </el-tooltip>
        <span v-else class="textOverflow">
            {{scope.row.werks ? scope.row.werks : '-'}}
        </span>
      </template>
    </el-table-column>
    <el-table-column label="库存地点" min-width="80px" prop="lgort" align="center" show-overflow-tooltip>
      <template slot-scope="scope">
        <el-tooltip v-if="scope.row.lgorttx" :content="scope.row.lgorttx" class="item" effect="dark" placement="top" :open-delay="300">
          <span class="textOverflow">
            {{scope.row.lgort}}
          </span>
        </el-tooltip>
        <span v-else class="textOverflow">
          {{scope.row.lgort ? scope.row.lgort : '-'}}
        </span>
      </template>
    </el-table-column>
    <el-table-column label="移动类型" min-width="80px" prop="bwart" align="center" show-overflow-tooltip>
      <template slot-scope="scope">
        <span>{{ scope.row.bwart ? scope.row.bwart : '-' }}</span>
      </template>
    </el-table-column>
    <el-table-column label="年度" min-width="80px" prop="mjahr" align="center" show-overflow-tooltip>
      <template slot-scope="scope">
        <span>{{ scope.row.mjahr ? scope.row.mjahr : '-' }}</span>
      </template>
    </el-table-column>
    <el-table-column label="过账日期" min-width="100px" prop="budat" align="center" show-overflow-tooltip>
      <template slot-scope="scope">
        <span>{{ scope.row.budat ? scope.row.budat : '-' }}</span>
      </template>
    </el-table-column>
    <el-table-column label="入库员" max-width="80px" prop="bdmng" align="center" show-overflow-tooltip>
      <template slot-scope="scope">
        <el-tooltip v-if="scope.row.user" :content="scope.row.user.name +'('+scope.row.user.employeeNum+') '+scope.row.createDateTime" class="item" effect="dark" placement="top" :open-delay="300">
          <span class="textOverflow">{{ scope.row.user.name }}({{scope.row.user.employeeNum}})</span>
        </el-tooltip>
        <span v-else>-</span>
      </template>
    </el-table-column>
    <el-table-column label="入库时间" min-width="140px" prop="createDateTime" align="center" show-overflow-tooltip>
      <template slot-scope="scope">
        <span>{{ scope.row.createDateTime ? scope.row.createDateTime : '-' }}</span>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
import {
  apiSapStorageExport
} from "@/api/SapOrder.js";
export default {
  props: {
    tabPaneValue: {
      type: String,
    },
    cutView: null,
    searchConditionForm: {type: Object},
    pagination: {}
  },
  computed: {
  },
  components: {
  },
  created() {
  },
  data() {
    return {
      dialogTitle: "【未命名】",
      dialogForm: {
      },
      tableData: null,
      dialogRules: {},
      labelWidth: this.$store.state.labelWidth
    };
  },
  methods: {
    async onSearch(callback) {
      this.tableData = [];
      const res = await apiSapStorageExport({
        ...this.searchConditionForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize
      });
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        if (callback) {callback();}
      }
    }
  }
};
</script>
<style>
.el-table .warning-row {
  color: #F56C6C;
}
</style>
